import { create } from 'zustand';

export const useStateCountyStore = create(set => ({
  stateCountyData: [],
  setStateCountyData: stateCountyData => set({ stateCountyData }),
}));
